export  var ModuleType =  {
  marketPlace:1,
  event:2,
}